// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1zNZY","name":"ConsentHeader_name__3mcPo","birthday":"ConsentHeader_birthday__3YTO9","skeleton":"ConsentHeader_skeleton__2htn4"};